import { createFileRoute } from '@tanstack/react-router';
import { ConnectPage } from '@/admin/connect/ConnectPage';
import { CONNECT_TABS, type ConnectTab } from '@/admin/connect/tabs';

export const Route = createFileRoute('/admin/connect/')({
  component: ConnectPage,
  staticData: { minTier: 'FRONT_END_SUPPORT' },
  // An unknown tab falls back to the first, so a stale link still lands.
  validateSearch: (search: Record<string, unknown>): { tab: ConnectTab } => ({
    tab: CONNECT_TABS.find((tab) => tab === search.tab) ?? 'targets',
  }),
});
